import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, Pipe, PipeTransform, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppConstants } from '../AppConstants';
import { AuthService } from '../service/auth.service';
import {ThemePalette} from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

@Pipe({
  name: 'fill'
})
export class FillPipe implements PipeTransform {
  transform(value) {
    return (new Array(value)).fill(1);
  }
}

// This lets me use jquery
declare var $: any;

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css'],
  providers: [DatePipe]
})
export class ProductComponent implements OnInit {

  showAddNewProductForm = false;
  showUpdateProductForm = false;
  // showAddNewRatesButton = true;
  productFormGroup: FormGroup;
  updateproductFormGroup: FormGroup;
  clickedProductDetails;
  sessionIdsToDelete: Array<number> = [];
  isCapacityPerVenueRequired = false;
  // rates = [];
  removable = true;
  showMultipleBookingsOption = false;
  showSingleBookingsOption = false;
  sessionTypeSelected: 'single' | 'multi' | 'addOn' | null = null;
  // AddOns: a product type with only name, description, price and an image (not bookable).
  showAddOnOption = false;
  addOnImageFile: File | null = null;
  addOnImagePreview: string | null = null;
  addOnImageError = '';
  readonly maxAddOnImageSizeInBytes = 2 * 1024 * 1024;
  readonly allowedAddOnImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  selectedStartTimeValue: Array<string> = [];;
  //selectedStartTimeValueSingleBooking: Array<string> = [];
  //selectedStartTimeValueMultiBooking: Array<string> = [];
    advancePricing: Array<number[]> = new Array<number[]>();
    addSessionClicked = false;
  //advancePricingForSingleBooking: Array<number[]> = new Array<number[]>();
  //advancePricingForMultiBooking: Array<number[]> = new Array<number[]>();
  successMessage: string = '';
  errorMessage: string = '';

  sessionIDofSelectedSessionOfExistingProduct;
  selectedEndTimeValue: Array<string> = [];
  //selectedEndTimeValueMultiBooking: Array<string> = [];
  //selectedEndTimeValueSingleBooking: Array<string> = [];
  timeSlotsForAdvancePricing: Array<string[]> = new Array<string[]>();
  //timeSlotsForSingleBooking: Array<string[]> = new Array<string[]>();
  //timeSlotsForMultiBooking: Array<string[]> = new Array<string[]>();
  zeros = 0;
  thirty = 30;
  startTimeOptions = [];
  endTimeOptions = [];
  filteredEndTimeOptions: string[] = [];
  selectedStartTime: string | null = null;

  dateObj = new Date();
  noOfSessionsToDisplay = 1;
  //noOfSessionsToDisplayForMultiBooking = 1;

  //productSubTypes = ["Monthly", "Sessions", "Flexible"];
  productSubTypes = ["Monthly", "Flexible"]; //Sessions Product is not fully developed yet so removing it for now.
  public selectedProductSubTypeValue;
  selectedFrequencyValue = 1;
  frequencyForMonthlySubType = [];
  months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  chips: string[] = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
  ];

  columnDefs = [
    { headerName: 'NAME', field: 'productName', flex: 1 }, // Use flex for responsive width
    { headerName: 'DURATION', field: 'durationPerSlot', flex: 1,
      valueFormatter: params => params.data?.productType === AppConstants.ADD_ONS ? '-' : params.value },
    { headerName: 'STATUS', field: 'status', flex: 1 },
    { headerName: 'TYPE', field: 'productType', flex: 1,
      valueFormatter: params => params.value === AppConstants.ADD_ONS ? 'Add-On' : params.value },
    { headerName: 'ID', field: 'id', width: 100 } // Fixed width for ID

];

rowData = [];
originalCopy = [];
serviceTypes: { id: number; value: string; label: string }[] = [];
  private gridApi;
  private gridColumnApi;
  private isfreshlyOpened: Map<number, boolean> = new Map<number, boolean>();
  private chipCollection: Map<string, boolean> = new Map<string, boolean>();
  private chipCollectionForSingleBookingOccurenceOptions: Map<string, boolean>[] = [];
  private chipCollectionForMultiBookingOccurenceOptions: Map<string, boolean>[] = [];
  // for status toggle
  color: ThemePalette = 'primary';
  isChecked = true;
  checked = true;
  disabled = false;
  tenantId;

  // Modal Popup
  modalPopupReference;
  advancePricingModalReference;
  timeSlotsToShowInModalPopup;
  advanceModalPopupOpenedIndex;
  //advanceModalPopupOpenedIndexSingleBooking;
  @ViewChild('content', {static: false}) content: TemplateRef<any>;
  @ViewChild('advancePricingModal', {static: false}) advancePricingModal: TemplateRef<any>;

  //Product Edit
  // noOfSessionsToDisplayInProductEditAfterAddingNew = 0;
  noOfSessionAddedInProductEditButNotSubmit = 0;
  productEditAddSessionChips: string[] = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
  ];
  private chipCollectionForBookingEditProductAddSession: Map<string, boolean>[] = [];
  //selectedStartTimeValueSingleBookingEditProduct: Array<string> = [];
  //selectedEndTimeValueSingleBookingEditProduct: Array<string> = [];
  //private isfreshlyOpenedEditProductAddSession: Map<number, boolean> = new Map<number, boolean>();
  //timeSlotsForSingleBookingEditProductAddSession: Array<string[]> = new Array<string[]>();
  //advanceModalPopupOpenedIndexSingleBookingEditProduct;
  //timeSlotsToShowInModalPopupEditProduct;
  //advancePricingForSingleBookingEditSession: Array<number[]> = new Array<number[]>();
  modalPopupReferenceEditProduct;
  @ViewChild('contentEditProduct', {static: false}) contentEditProduct: TemplateRef<any>;

  public radioOptionsSetForMonthlyMultiBooking = ['Start Any Day', 'Selected Dates'];
  public selectedOptionForMonthlyMultiBooking = '';
  public isSelectedDateRequired = false;

  constructor(private modalService: NgbModal, private datePipe: DatePipe, private authService: AuthService, private dialog: MatDialog, private snackBar: MatSnackBar ) {
    this.tenantId = JSON.parse(sessionStorage.getItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT)).tenantId;
   }

  ngOnInit() {

    if( AppConstants.SESSION_STORAGE_ROLEID == 1)
    {
        //console.log("Tenant Id products ", AppConstants.SESSION_STORAGE_TENANTID);
        this.tenantId = AppConstants.SESSION_STORAGE_TENANTID;
        //console.log("Tenant Id ", this.tenantId);
        //console.log("user", this.user);
    }

    this.getAllProductsByTenantId();
    this.loadServiceTypes();

    this.productFormGroup = new FormGroup({
      allowBookingFormControl: new FormControl(true),
      isCoachingFormControl: new FormControl(true),
      serviceTypeFormControl: new FormControl('', [Validators.required]),
      productNameFormControl: new FormControl('', [
        Validators.required
      ]),
      productRateFormControl: new FormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]+$') // allows integers & decimals
      ]),
      productDurationFormControl: new FormControl('', [
        Validators.required,
        Validators.min(5),
        Validators.pattern('^[1-9][0-9]*$')
      ]),
      productDescriptionFormControl: new FormControl('', [
        Validators.required
      ]),
      productCapacityPerVenueFormControl: new FormControl(1, [
        Validators.required,
        Validators.min(1),
        Validators.pattern('^[1-9][0-9]*$')
      ]),
      startTimeForSingleSessionFormContol: new FormControl('', [

      ]),
      endTimeForSingleSessionFormContol: new FormControl('', [

      ]),
      selectedProductSubTypeValue: new FormControl(''),
      selectedFrequencyValue: new FormControl(1, [
        Validators.required,
        Validators.min(1),
        Validators.pattern('^[1-9][0-9]*$')
        ]),
      selectedDatesFormControl: new FormControl('', [

      ]),
      // Single-session booking window: 'RollingDays' (allow for next N days) or 'UptoDate' (allow up to a fixed date).
      bookingWindowTypeFormControl: new FormControl('RollingDays'),
      bookingWindowDaysFormControl: new FormControl(30, [
        Validators.min(1),
        Validators.pattern('^[1-9][0-9]*$')
      ]),
      bookingWindowUptoDateFormControl: new FormControl('')
    });

    // (this.productFormGroup.get("selectedDatesFormControl") as FormControl).valueChanges.subscribe(value => {
    //   console.log(value);
    //   this.updateValidation(value);
    // });

    this.updateproductFormGroup = new FormGroup({
      updateAllowBookingFormControl: new FormControl(true),
      updateIsCoachingFormControl: new FormControl(true),
      updateServiceTypeFormControl: new FormControl('', [Validators.required]),
      updateProductNameFormControl: new FormControl('', [

      ]),
      updateProductDescriptionFormControl: new FormControl('', [

      ]),
      updateProductRateFormControl: new FormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]+$')
      ]),
      updateProductDurationFormControl: new FormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]+$')
      ]),
      updateProductCapacityPerVenueFormControl: new FormControl(1, [
        Validators.min(1)
      ]),
      startTimeForSingleSessionEditProductFormContol: new FormControl('', [

      ]),
      endTimeForSingleSessionEditProductFormContol: new FormControl('', [

      ]),
      updateProductMultiSessionSessionsFormControl: new FormControl('', [

      ]),
      updateProductMultiSessionSessionsNoFormControl: new FormControl('', [

      ]),
      updateProductMultiSessionMonthlyFormControl: new FormControl('', [

      ]),
      updateProductMultiSessionMonthlyNoFormControl: new FormControl(1, [
        Validators.required,
        Validators.min(1),
        Validators.pattern('^[1-9][0-9]*$')
      ]),
      updateSelectedDatesFormControl: new FormControl('', [
      Validators.required,
      Validators.pattern(
        '^([1-9]|[12][0-9]|3[01])(\\s*,\\s*([1-9]|[12][0-9]|3[01]))*$'
      )
      ]),
      // Single-session booking window (edit form).
      updateBookingWindowTypeFormControl: new FormControl('RollingDays'),
      updateBookingWindowDaysFormControl: new FormControl(30, [
        Validators.min(1),
        Validators.pattern('^[1-9][0-9]*$')
      ]),
      updateBookingWindowUptoDateFormControl: new FormControl('')
    });

    for (const chip of this.chips) {
      this.chipCollection.set(chip, false);
    }

    this.addTime();
  }


  showAlertForOverridePricing(): void {
   console.log("Function: showAlertForOverridePricing ");
    this.advancePricingModalReference = this.modalService.open(this.advancePricingModal, { windowClass: 'advance-pricing-modal', ariaLabelledBy: 'modal-basic-title'});
  }

  onOKClick() {
    console.log("Function: onOKClick ");
    // Perform action when OK button is clicked
    this.closeDialog();
    this.proceedWithProductUpdate();
  }

  onCancelClick(): void {
    console.log("Function: onCancelClick ");
    this.closeDialog();
  }

  closeDialog(): void {
    console.log("Function: close dialog  ");
    this.advancePricingModalReference.dismiss();
  }
  incrementCapacity() {
    const control = this.showUpdateProductForm
      ? this.updateproductFormGroup.get('updateProductCapacityPerVenueFormControl')
      : this.productFormGroup.get('productCapacityPerVenueFormControl');

    let value = Number(control?.value) || 1;
    control?.setValue(value + 1);
  }

  decrementCapacity() {
    const control = this.showUpdateProductForm
      ? this.updateproductFormGroup.get('updateProductCapacityPerVenueFormControl')
      : this.productFormGroup.get('productCapacityPerVenueFormControl');

    let value = Number(control?.value) || 1;

    if (value > 1) {
      control?.setValue(value - 1);
    }
  }
  preventDecimal(event: KeyboardEvent) {
    if (event.key === '.' || event.key === '-' || event.key === 'e') {
      event.preventDefault();
    }
  }

  displayAdvancePricingPopup(index: number, existingSession: Boolean = false) {

    console.log('Function: In displayAdvancePricingPopup', index);

    this.advanceModalPopupOpenedIndex = index;
    this.timeSlotsToShowInModalPopup = this.timeSlotsForAdvancePricing[index];

    let rate = this.showUpdateProductForm
      ? Number(this.updateproductFormGroup.get('updateProductRateFormControl').value)
      : Number(this.productFormGroup.get('productRateFormControl').value);

    // NEW SESSION
    if (!existingSession) {

      if (!this.advancePricing[index] || this.advancePricing[index].length === 0) {

        this.advancePricing[index] =
          new Array<number>(this.timeSlotsForAdvancePricing[index].length - 1)
            .fill(rate);
      }

      //console.log('Using new session pricing', this.advancePricing[index]);
    }

    // EXISTING SESSION
    else {

      let venueId =
        this.clickedProductDetails.sessions[index]?.timeslotWiseProduct?.[0]?.venueId;

      this.advancePricing[index] =
        this.clickedProductDetails.sessions[index]?.timeslotWiseProduct
          ?.filter(slot => slot.venueId === venueId)
          ?.sort((a, b) => {

            const [aHour, aMin] = a.startTime.split(':').map(Number);
            const [bHour, bMin] = b.startTime.split(':').map(Number);

            return aHour - bHour || aMin - bMin;
          })
          ?.map(slot => slot.price) || [];

      console.log('Loaded existing session pricing', this.advancePricing[index]);
    }

    this.modalPopupReference = this.modalService.open(this.content, {

      centered: true,
      scrollable: true,
      windowClass: 'advance-pricing'
    });
  }

  loadServiceTypes() {
    this.authService.getAllServiceTypes().subscribe(
      (response: any[]) => {
        this.serviceTypes = response;
      },
      (error) => {
        console.error('Error loading service types:', error);
      }
    );
  }

  getAllProductsByTenantId() {
    console.log("Function: getAllProductsByTenantId ");
    //console.log("Tenant Id Product",  AppConstants.SESSION_STORAGE_TENANTID);
    if(AppConstants.SESSION_STORAGE_ROLEID == 1)
    {
      this.tenantId = AppConstants.SESSION_STORAGE_TENANTID;
    }

    //.log("product tennat id",  this.tenantId);
    this.authService.getAllProductsByTenantId(this.tenantId, true).subscribe(
      (response: any[]) => {
        this.rowData = response;
        this.originalCopy = JSON.parse(JSON.stringify(response));
      },
      (error) => {

      }
    );
  }

  onGridReady(params) {
    console.log("Function: onGridReady ");

    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  isOpenProduct: Boolean;

  onRowClicked(event: any) {
    console.log("Function: onRowClicked ");

    const hasUnsavedChanges = (this.showUpdateProductForm && this.updateproductFormGroup.dirty)
      || (this.showAddNewProductForm && this.productFormGroup.dirty);

    if (hasUnsavedChanges) {

      const confirmed = confirm(
        'Unsaved changes will be lost. Do you want to continue?'
      );

      if (!confirmed) {
        return;
      }
      this.onUpdateProductFormCancelClicked();
    }

    this.clickedProductDetails = event.data;
    this.addOnImageError = '';
    this.clearAddOnImage();
    // AddOns have no service type; restore the validator for every other product type.
    const updateServiceTypeControl = this.updateproductFormGroup.get('updateServiceTypeFormControl');
    updateServiceTypeControl.setValidators(this.isClickedAddOn() ? [] : [Validators.required]);
    updateServiceTypeControl.updateValueAndValidity();
    this.updateproductFormGroup.get('updateAllowBookingFormControl').setValue(this.clickedProductDetails.allowBooking || false);
    this.updateproductFormGroup.get('updateIsCoachingFormControl').setValue(this.clickedProductDetails.isCoaching || false);
    this.updateproductFormGroup.get('updateServiceTypeFormControl').setValue(this.clickedProductDetails.serviceType || '');
    this.updateproductFormGroup.get('updateProductNameFormControl').setValue(this.clickedProductDetails.productName);
    this.updateproductFormGroup.get('updateProductDescriptionFormControl').setValue(this.clickedProductDetails.description);
    this.updateproductFormGroup.get('updateProductRateFormControl').setValue(this.clickedProductDetails.price);
    this.updateproductFormGroup.get('updateProductDurationFormControl').setValue(this.clickedProductDetails.durationPerSlot);
    this.updateproductFormGroup.get('updateProductDurationFormControl')?.clearValidators();
    this.updateproductFormGroup.get('updateProductDurationFormControl')?.updateValueAndValidity();
    this.updateproductFormGroup.get('updateProductCapacityPerVenueFormControl').setValue(this.clickedProductDetails.capacityPerVenue);
    this.updateproductFormGroup.get('updateProductMultiSessionSessionsFormControl').setValue(this.clickedProductDetails.sessionType);
    this.updateproductFormGroup.get('updateProductMultiSessionSessionsNoFormControl').setValue(this.clickedProductDetails.noOfSessions);
    this.updateproductFormGroup.get('updateProductMultiSessionMonthlyFormControl').setValue(this.clickedProductDetails.sessionType);
    this.updateproductFormGroup.get('updateProductMultiSessionMonthlyFormControl')?.disable();
    this.updateproductFormGroup.get('updateProductMultiSessionMonthlyNoFormControl').setValue(this.clickedProductDetails.noOfSessions || 1);
    this.updateproductFormGroup.get('updateSelectedDatesFormControl').setValue(this.clickedProductDetails.monthlyMultiBookingSelectedDates);

    // Single-session booking window (defaults preserve the legacy 30-day rolling behaviour).
    const bwType = this.clickedProductDetails.bookingWindowType || 'RollingDays';
    const bwValue = this.clickedProductDetails.bookingWindowValue;
    this.updateproductFormGroup.get('updateBookingWindowTypeFormControl').setValue(bwType === 'UptoDate' ? 'UptoDate' : 'RollingDays');
    this.updateproductFormGroup.get('updateBookingWindowDaysFormControl').setValue(bwType === 'RollingDays' && bwValue ? Number(bwValue) : 30);
    this.updateproductFormGroup.get('updateBookingWindowUptoDateFormControl').setValue(bwType === 'UptoDate' ? (bwValue || '') : '');

    this.updateproductFormGroup.markAsPristine();
    this.updateproductFormGroup.markAsUntouched();

    Object.keys(this.updateproductFormGroup.controls).forEach(key => {
      this.updateproductFormGroup.get(key)?.updateValueAndValidity();
    });


    this.selectedOptionForMonthlyMultiBooking = this.clickedProductDetails.monthlyMultiBookingOption;
    this.isOpenProduct = this.clickedProductDetails.sessionType === "Flexible";
    if(this.clickedProductDetails.status == AppConstants.STATUS_ACTIVE) {
      this.isChecked = true;
    } else {
      this.isChecked = false;
    }
    //console.log("Clicked Row: ", event.data);
    this.showAddNewProductForm = false;
    this.showUpdateProductForm = true;
    this.noOfSessionAddedInProductEditButNotSubmit = 0;
    this.addSessionClicked = false;
    this.addTime();//Set the Time options for sessions.

    if (this.isClickedProductSingleSession()) {

      this.updateproductFormGroup.get('updateProductMultiSessionMonthlyNoFormControl')
        ?.clearValidators();

      this.updateproductFormGroup.get('updateProductMultiSessionSessionsNoFormControl')
        ?.clearValidators();

      this.updateproductFormGroup.get('updateProductMultiSessionMonthlyNoFormControl')
        ?.setErrors(null);

      this.updateproductFormGroup.get('updateProductMultiSessionSessionsNoFormControl')
        ?.setErrors(null);

      this.updateproductFormGroup.get('updateProductMultiSessionMonthlyNoFormControl')
        ?.updateValueAndValidity();

      this.updateproductFormGroup.get('updateProductMultiSessionSessionsNoFormControl')
        ?.updateValueAndValidity();
    }

    // Clear unused validators for Sessions type multi-session products
    if (this.isClickedMultiSessionSessions()) {

      this.updateproductFormGroup.get('updateProductMultiSessionMonthlyNoFormControl')
        ?.clearValidators();

      this.updateproductFormGroup.get('updateProductMultiSessionMonthlyNoFormControl')
        ?.setErrors(null);

      this.updateproductFormGroup.get('updateProductMultiSessionMonthlyNoFormControl')
        ?.updateValueAndValidity();
    }

    // Clear unused validators for Monthly products
    if (this.isClickedMultiSessionMonthly()) {

      ['startTimeForSingleSessionEditProductFormContol',
       'endTimeForSingleSessionEditProductFormContol',
       'updateProductMultiSessionSessionsNoFormControl',
       'updateProductCapacityPerVenueFormControl'
      ].forEach(controlName => {
        const control = this.updateproductFormGroup.get(controlName);
        control?.clearValidators();
        control?.setErrors(null);
        control?.updateValueAndValidity();
      });
    }

    if (this.isOpenProduct) {

      this.updateproductFormGroup.get('updateProductMultiSessionMonthlyNoFormControl')
        ?.clearValidators();

      this.updateproductFormGroup.get('updateProductMultiSessionSessionsNoFormControl')
        ?.clearValidators();

      this.updateproductFormGroup.get('startTimeForSingleSessionEditProductFormContol')
        ?.clearValidators();

      this.updateproductFormGroup.get('endTimeForSingleSessionEditProductFormContol')
        ?.clearValidators();

      Object.keys(this.updateproductFormGroup.controls).forEach(key => {
        this.updateproductFormGroup.get(key)?.setErrors(null);
        this.updateproductFormGroup.get(key)?.updateValueAndValidity();
      });
    }

  }

  isClickedProductSingleSession() {

    //console.log("Function: isClickedProductSingleSession ");
    return this.clickedProductDetails.productType == "Single Session" ? true : false;
  }

  /**
   * Builds the booking-window part of the product payload from the given form group.
   * Only single-session products carry a configurable window; everything else sends nulls.
   * `prefix` is 'bookingWindow' (create form) or 'updateBookingWindow' (edit form).
   */
  private getBookingWindowPayload(formGroup: any, prefix: string) {
    const isSingle = prefix === 'bookingWindow'
      ? this.showSingleBookingsOption
      : this.isClickedProductSingleSession();

    if (!isSingle) {
      return { bookingWindowType: null, bookingWindowValue: null };
    }

    const type = formGroup.get(prefix + 'TypeFormControl')?.value;
    const days = formGroup.get(prefix + 'DaysFormControl')?.value;
    const uptoDate = formGroup.get(prefix + 'UptoDateFormControl')?.value;

    // value holds the date (UptoDate) or the day count (RollingDays).
    if (type === 'UptoDate') {
      return {
        bookingWindowType: 'UptoDate',
        bookingWindowValue: uptoDate ? this.datePipe.transform(uptoDate, 'yyyy-MM-dd') : null
      };
    }
    return {
      bookingWindowType: 'RollingDays',
      bookingWindowValue: (days !== null && days !== '' && days !== undefined) ? String(Number(days)) : null
    };
  }

  isClickedProductMultiSession() {
  //console.log("Function: isClickedProductMultiSession ");
    return this.clickedProductDetails.productType == "Multi Session" ? true : false;
  }

  isClickedMultiSessionSessions() {
  //console.log("Function: isClickedMultiSessionSessions ");
    return this.clickedProductDetails.productType === "Multi Session" && this.clickedProductDetails.sessionType === "Sessions" ? true : false;
  }

  isClickedMultiSessionMonthly() {
  //console.log("Function: isClickedMultiSessionMonthly ");
    return this.clickedProductDetails.productType === "Multi Session" && this.clickedProductDetails.sessionType === "Monthly" ? true : false;
  }

  isSessionSelectedOnGivenDay(chip: string, index: number) {
  //console.log("Function: isSessionSelectedOnGivenDay ");
    return this.clickedProductDetails.sessions[index][chip.toLowerCase()];
  }

  clickedDeleteSessionEditProduct(session) {
  console.log("Function: clickedDeleteSessionEditProduct ");
    const index = this.clickedProductDetails.sessions.findIndex((value) => value.id === session.id);
    this.clickedProductDetails.sessions.splice(index, 1);
    this.sessionIdsToDelete.push(Number(session.id));
    //console.log(this.sessionIdsToDelete);
    this.addSessionClicked = false;
  }
  handleDeleteExistingSession(session: any) {

    if (this.addSessionClicked) {
      alert(
        'Please complete new session configuration first.'
      );
      return;
    }
    this.clickedDeleteSessionEditProduct(session);
  }

  onUpdateProductFormSaveClicked() {
  console.log("Function: onUpdateProductFormSaveClicked ");
    const price = this.updateproductFormGroup.get('updateProductRateFormControl').value;
    // AddOns have no time slots, so there is no advance pricing to overwrite.
    if(price !== this.clickedProductDetails.price && !this.isClickedAddOn()) {
      this.showAlertForOverridePricing();
    } else {
      this.proceedWithProductUpdate();
    }
  }

  addSessionForProductEdit() {
    console.log("Function: addSessionForProductEdit ");
    //console.log("this.noOfSessionAddedInProductEditButNotSubmit", this.noOfSessionAddedInProductEditButNotSubmit );

    this.noOfSessionAddedInProductEditButNotSubmit = this.noOfSessionAddedInProductEditButNotSubmit + 1;
    // this.noOfSessionsToDisplayInProductEditAfterAddingNew = this.noOfSessionsToDisplayInProductEditAfterAddingNew + 1;

    this.addSessionClicked = true;

  }
  proceedWithProductUpdate() {

    console.log("Function: proceedWithProductUpdate ");

    const updatedProductName  = this.updateproductFormGroup.get('updateProductNameFormControl').value?.trim();
    const updatedProductName_backup  = this.updateproductFormGroup.get('updateProductNameFormControl').value?.trim()?.toLowerCase();
    const duplicateProduct = this.rowData.find(product =>

        product.id !== this.clickedProductDetails.id &&

        product.productName?.trim()?.toLowerCase() === updatedProductName_backup
      );

      if (duplicateProduct) {

        alert('Service name already exists.');

        return;
      }


    const description = this.updateproductFormGroup.get('updateProductDescriptionFormControl').value;
    const price = this.updateproductFormGroup.get('updateProductRateFormControl').value;
    const durationPerSlot = this.updateproductFormGroup.get('updateProductDurationFormControl').value;
    const capacityPerVenue = this.updateproductFormGroup.get('updateProductCapacityPerVenueFormControl').value;

    let noOfSessions;
    let monthlyMultiBookingSelectedDates;

    if(this.isClickedMultiSessionMonthly()) {

      noOfSessions =
        this.updateproductFormGroup.get('updateProductMultiSessionMonthlyNoFormControl').value;

      monthlyMultiBookingSelectedDates =
        this.updateproductFormGroup.get('updateSelectedDatesFormControl').value;

    } else {

      noOfSessions =
        this.updateproductFormGroup.get('updateProductMultiSessionSessionsNoFormControl').value;
    }

    const productStatus = this.getProductStatusValue();

    const allowBooking = this.updateproductFormGroup.get('updateAllowBookingFormControl').value;
    const isCoaching  = this.updateproductFormGroup.get('updateIsCoachingFormControl').value;
    const serviceType = this.updateproductFormGroup.get('updateServiceTypeFormControl').value;

    const updateProductRequest = {
      productName: updatedProductName,
      price: Number(price),
      description: description,
      durationPerSlot: durationPerSlot,
      capacityPerVenue: capacityPerVenue,
      status: productStatus,
      noOfSessions: noOfSessions,
      monthlyMultiBookingSelectedDates: monthlyMultiBookingSelectedDates,
      allowBooking: allowBooking,
      isCoaching: isCoaching,
      serviceType: serviceType,
      ...this.getBookingWindowPayload(this.updateproductFormGroup, 'updateBookingWindow')
    };

    console.log("proceedWithProductUpdate", updateProductRequest);

    this.authService.updateProduct(this.clickedProductDetails.id, updateProductRequest).subscribe(

      (response: any) => {

        console.log('Product details updated successfully', response);

        this.snackBar.open('Service updated successfully!', '', {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: ['snackbar-success']
        });

        // DELETE SESSIONS
        for(let i = 0; i < this.sessionIdsToDelete.length; i++) {

          this.authService.deleteSessionById(this.sessionIdsToDelete[i]).subscribe(
            (response: any) => {

              //console.log('Successfully deleted sessionId ', this.sessionIdsToDelete[i]);

            },
            (error) => {

              console.log('Error while deleting sessionId ', this.sessionIdsToDelete[i]);
            }
          );
        }

        // CREATE NEWLY ADDED SESSIONS
        if(this.noOfSessionAddedInProductEditButNotSubmit > 0) {

          const getSelectedSingleBookingOptionForSessionEditProduct =
            this.getSelectedBookingEditProductAddSession();

          /* console.log(
            "timeSlotsForAdvancePricing",
            this.timeSlotsForAdvancePricing
          ); */

          for (
            let counter = 0;
            counter < getSelectedSingleBookingOptionForSessionEditProduct.length;
            counter++
          ) {

            // 🔥 IMPORTANT FIX
            const actualIndex =
              this.clickedProductDetails.sessions.length + counter;

            const timeSlotsArray =
              this.timeSlotsForAdvancePricing[actualIndex];

            //console.log("timeSlotsArray: ", timeSlotsArray);

            const startTime = timeSlotsArray[0];
            const endTime = timeSlotsArray[timeSlotsArray.length - 1];

            const map =
              getSelectedSingleBookingOptionForSessionEditProduct[counter];

            const monday = map.get(this.chips[0]) === true;
            const tuesday = map.get(this.chips[1]) === true;
            const wednesday = map.get(this.chips[2]) === true;
            const thursday = map.get(this.chips[3]) === true;
            const friday = map.get(this.chips[4]) === true;
            const saturday = map.get(this.chips[5]) === true;
            const sunday = map.get(this.chips[6]) === true;

            const sessionRequest = {
              tenantId: this.tenantId,
              productId: response.id,
              startTime: startTime,
              endTime: endTime,
              monday: monday,
              tuesday: tuesday,
              wednesday: wednesday,
              thursday: thursday,
              friday: friday,
              saturday: saturday,
              sunday: sunday
            };

            //console.log("sessionRequest", sessionRequest);

            this.authService.createSession(sessionRequest).subscribe(

              (createSessionResponse: any) => {

                console.log('Session/s created successfully.');

                let timeslotWiseProductRequestArray: Array<any> = [];

                for(let i = 0; i < timeSlotsArray.length - 1; i++) {

                  const timeslotWiseProductRequest = {
                    tenantId: this.tenantId,
                    startTime: this.convert12HourTo24HourFormat(timeSlotsArray[i]),
                    endTime: this.convert12HourTo24HourFormat(timeSlotsArray[i + 1]),

                    // 🔥 IMPORTANT FIX
                    price: this.advancePricing[actualIndex][i],

                    productId: response.id,
                    sessionId: createSessionResponse.id
                  };

                  timeslotWiseProductRequestArray.push(
                    timeslotWiseProductRequest
                  );
                }

                /* console.log(
                  "timeslotWiseProductRequestArray",
                  timeslotWiseProductRequestArray
                ); */

                this.authService.createTimeSlotWiseProducts(
                  timeslotWiseProductRequestArray
                ).subscribe(

                  (createTimeSlotWiseProductsByProductIdResponse: any) => {

                    console.log(
                      'Successfully created timeslot wise products'
                    );

                    this.getAllProductsByTenantId();

                    this.showUpdateProductForm = false;

                    this.resetUpdateProductForm();

                    this.noOfSessionAddedInProductEditButNotSubmit = 0;
                  },

                  (error: HttpErrorResponse) => {

                    console.log(error);

                    this.snackBar.open('Slot Creation Failed!', '', {
                      duration: 5000,
                      verticalPosition: 'bottom',
                      horizontalPosition: 'center',
                      panelClass: ['snackbar-error']
                    });
                  }
                );
              },

              (error: HttpErrorResponse) => {

                console.log(error.error.errors[0].message);

                alert(error.error.errors[0].message);

                this.snackBar.open('Service update failed!', '', {
                  duration: 5000,
                  verticalPosition: 'bottom',
                  horizontalPosition: 'center',
                  panelClass: ['snackbar-error']
                });
              }
            );
          }

        } else if (this.isClickedAddOn()) {

          this.uploadAddOnImageIfSelected(this.clickedProductDetails.id, () => {
            this.clearAddOnImage();
            this.getAllProductsByTenantId();
            this.showUpdateProductForm = false;
          });

        } else {

          this.getAllProductsByTenantId();

          this.showUpdateProductForm = false;
        }
      },

      (error) => {

        console.log('Error while updating product details', error);

        this.snackBar.open('Service update failed!', '', {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: ['snackbar-error']
        });
      }
    );
  }

  handleExistingSessionAdvancePricing(index: number, sessionId: number) {

    if (this.addSessionClicked) {

      alert('Please complete new session configuration first.');

      return;
    }

    this.clickedAdvancedPricingForExistingSessions(index, sessionId);
  }

  onUpdateProductFormCancelClicked() {
    console.log("Function: onUpdateProductFormCancelClicked ");
    this.showUpdateProductForm = false;

    this.resetUpdateProductForm();
    this.clearChipBookingEditProductAddSession();
    this.selectedStartTimeValue = [];
    this.selectedEndTimeValue = [];
    this.endTimeOptions.length = 0;
    this.startTimeOptions.length = 0;
    this.noOfSessionAddedInProductEditButNotSubmit = 0;
    this.sessionIdsToDelete = [];
    this.addOnImageError = '';
    this.clearAddOnImage();
    this.getAllProductsByTenantId();
    this.closeProductForms();

  }

  resetUpdateProductForm() {
  console.log("Function: resetUpdateProductForm ");
    this.updateproductFormGroup.reset({
      updateProductMultiSessionMonthlyNoFormControl: 1
    });
  }

  resetCreateProductForm() {
    console.log("Function: resetCreateProductForm ");

    this.sessionTypeSelected = null;
    this.productFormGroup.reset({
        allowBookingFormControl: true,
        isCoachingFormControl: true,
        productCapacityPerVenueFormControl: 1,
        selectedFrequencyValue: 1
    });

    // 🔥 CRITICAL FIXES
    this.chipCollectionForSingleBookingOccurenceOptions = [];
    this.chipCollectionForMultiBookingOccurenceOptions = [];
    this.advancePricing = [];
    this.timeSlotsForAdvancePricing = [];

    this.selectedStartTimeValue = [];
    this.selectedEndTimeValue = [];

    this.noOfSessionsToDisplay = 1;
    this.addSessionClicked = false;

    this.showAddOnOption = false;
    this.addOnImageError = '';
    this.clearAddOnImage();
    this.setAddOnValidators(false);

    // Reset capacity default again
    this.productFormGroup.get('productCapacityPerVenueFormControl')?.setValue(1);
  }

  clickAddNewProduct() {
    console.log("Function: clickAddNewProduct ");
    this.resetCreateProductForm();
    this.clearCreateAndUpdateFormData(); //Reset form data if anything is set in the previous editing
    this.showUpdateProductForm = false;
    this.showAddNewProductForm = true;
  }

  addTime() {

    console.log("Add Time");

    //Clearing the array before initializing
    this.startTimeOptions.length = 0
    this.endTimeOptions.length = 0
    this.filteredEndTimeOptions.length = 0

    for (let hour = 0; hour <= 23; hour++) {
        let time1 = this.datePipe.transform(this.dateObj.setHours(hour, this.zeros), 'h:mm a');
        let time2 = this.datePipe.transform(this.dateObj.setHours(hour, this.thirty), 'h:mm a');
        //console.log(time1);
        if (time1) {
          this.startTimeOptions.push(time1);
          this.endTimeOptions.push(time1);
        }

        if (time2) {
          this.startTimeOptions.push(time2);
          this.endTimeOptions.push(time2);
        }
      }

  }

  // clickedAddNewRatesButton() {
  //   this.showAddNewRatesButton = false;
  // }

  // createNewRate() {
  //   this.rates.push(this.rateFormGroup.get('rateFormControl').value);
  // }

  // deleteRate(rate) {
  //   this.rates = this.rates.filter(rate => rate !== rate);
  // }

  productTypeChipsClickedSingleBooking(){
    console.log("Function: productTypeChipsClickedSingleBooking ");

    // 🚫 Block switching
    if (this.sessionTypeSelected && this.sessionTypeSelected !== 'single') {
      return;
    }

    // ✅ THIS LINE IS MISSING (critical)
    this.sessionTypeSelected = 'single';

    document.getElementById("multi-session").classList.remove("selected-chip");
    document.getElementById("single-session").classList.add("selected-chip");

    this.showMultipleBookingsOption = false;
    this.showSingleBookingsOption = true;
    this.isCapacityPerVenueRequired = true;

    this.addTime();

    if(this.noOfSessionsToDisplay > 0) {
      this.addSessionClicked = true;
    }

    console.log('Add new : Product Type Selected- Single Booking');
  }

  getCapacityPerVenueRequired() {
    //console.log("Function: getCapacityPerVenueRequired ");
    const productCapacityPerVenueFormControlValue: string = this.productFormGroup.get('productCapacityPerVenueFormControl').value;
    //console.log("Function: getCapacityPerVenueRequired ", productCapacityPerVenueFormControlValue);
    return this.isCapacityPerVenueRequired && (productCapacityPerVenueFormControlValue == null || productCapacityPerVenueFormControlValue == '');
  }

  productTypeChipsClickedMultipleBooking(){
    console.log("Function: productTypeChipsClickedMultipleBooking ");

    // 🚫 Block switching
    if (this.sessionTypeSelected && this.sessionTypeSelected !== 'multi') {
      return;
    }

    // ✅ THIS LINE IS MISSING (critical)
    this.sessionTypeSelected = 'multi';

    document.getElementById("single-session").classList.remove("selected-chip");
    document.getElementById("multi-session").classList.add("selected-chip");

    this.showSingleBookingsOption = false;
    this.showMultipleBookingsOption = true;
    this.isCapacityPerVenueRequired = false;
    this.addTime();

    if(this.noOfSessionsToDisplay > 0) {
      this.addSessionClicked = true;
    }
    console.log('Add new : Product Type Selected- Multiple Booking');
  }

  productTypeChipsClickedAddOn() {
    console.log("Function: productTypeChipsClickedAddOn ");

    // 🚫 Block switching
    if (this.sessionTypeSelected && this.sessionTypeSelected !== 'addOn') {
      return;
    }

    this.sessionTypeSelected = 'addOn';
    this.showSingleBookingsOption = false;
    this.showMultipleBookingsOption = false;
    this.showAddOnOption = true;
    this.isCapacityPerVenueRequired = false;
    this.addSessionClicked = false;
    this.setAddOnValidators(true);
  }

  /** AddOns have no duration or service type, so those validators only apply to bookable services. */
  private setAddOnValidators(isAddOn: boolean) {
    const duration = this.productFormGroup.get('productDurationFormControl');
    const serviceType = this.productFormGroup.get('serviceTypeFormControl');
    if (isAddOn) {
      duration?.clearValidators();
      serviceType?.clearValidators();
    } else {
      duration?.setValidators([Validators.required, Validators.min(5), Validators.pattern('^[1-9][0-9]*$')]);
      serviceType?.setValidators([Validators.required]);
    }
    duration?.updateValueAndValidity();
    serviceType?.updateValueAndValidity();
  }

  isClickedAddOn(): boolean {
    return this.clickedProductDetails?.productType === AppConstants.ADD_ONS;
  }

  onAddOnImageSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files.length ? input.files[0] : null;
    this.addOnImageError = '';

    if (!file) {
      return;
    }
    if (!this.allowedAddOnImageTypes.includes(file.type)) {
      this.addOnImageError = 'Only JPG, PNG or WEBP images are allowed.';
      input.value = '';
      return;
    }
    if (file.size > this.maxAddOnImageSizeInBytes) {
      this.addOnImageError = 'Image must be 2 MB or smaller.';
      input.value = '';
      return;
    }

    this.clearAddOnImage();
    this.addOnImageFile = file;
    this.addOnImagePreview = URL.createObjectURL(file);
  }

  clearAddOnImage() {
    if (this.addOnImagePreview) {
      URL.revokeObjectURL(this.addOnImagePreview);
    }
    this.addOnImageFile = null;
    this.addOnImagePreview = null;
  }

  /** Uploads the selected image for the given addOn, if one was picked. Calls done() either way. */
  private uploadAddOnImageIfSelected(productId: number, done: () => void) {
    if (!this.addOnImageFile) {
      done();
      return;
    }
    this.authService.uploadProductImage(productId, this.addOnImageFile).subscribe(
      () => done(),
      (error) => {
        console.log('Error while uploading addOn image', error);
        this.snackBar.open('Add-On saved, but image upload failed!', '', {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: ['snackbar-error']
        });
        done();
      }
    );
  }

  private createAddOn(productName: string, description: string, price: any, productStatus: string) {
    console.log("Function: createAddOn ");

    if (!productName) {
      alert('Add-On name is required.');
      return;
    }
    if (price === null || price === '' || isNaN(Number(price)) || Number(price) < 0) {
      alert('Please enter a valid price.');
      return;
    }

    const productRequest = {
      productName: productName,
      description: description || '',
      status: productStatus,
      price: Number(price),
      durationPerSlot: 0,
      capacityPerVenue: 0,
      productType: AppConstants.ADD_ONS,
      tenantId: this.tenantId,
      allowBooking: false,
      isCoaching: false,
      serviceType: ''
    };

    this.authService.createProduct(productRequest).subscribe(
      (response: any) => {
        this.uploadAddOnImageIfSelected(response.id, () => {
          this.snackBar.open('Add-On created successfully!', '', {
            duration: 5000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            panelClass: ['snackbar-success']
          });
          this.closeCreateForm();
        });
      },
      (error) => {
        console.log(error);
        this.snackBar.open('Failed to create Add-On. Please try again.', '', {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: ['snackbar-error']
        });
      }
    );
  }

  openProductSelected:boolean = false;
  selectValueChangeForProductSubType(event) {
    console.log("Function: selectValueChangeForProductSubType ");
    this.openProductSelected = event.target.value === "Flexible";
  }
  productTypeChipsClickedOpenProduct() {
    this.openProductSelected = true;

    // 🔥 Clear sessions completely
    this.noOfSessionsToDisplay = 0;
    this.resetSessions();
    /* this.sessions = []; */
  }

  resetSessions() {
    this.noOfSessionsToDisplay = 0;

    if (this.clickedProductDetails?.sessions) {
      this.clickedProductDetails.sessions = [];
    }
  }

  isSelectedMultiBooking(chip: any, index: number) {
  //console.log("Function: isSelectedMultiBooking ");
    //console.log("test log");
    //console.log(this.chipCollectionForMultiBookingOccurenceOptions[index]);
    if(this.chipCollectionForMultiBookingOccurenceOptions[index] && this.chipCollectionForMultiBookingOccurenceOptions[index].get(chip)) {
      return true;
    }
  }

  isSelectedSingleBooking(chip: any, index: number) {
  //console.log("Function: isSelectedSingleBooking ");
    //console.log("test log");

    //console.log("Index: ", index, this.chipCollectionForMultiBookingOccurenceOptions[index]);
    /* console.log("Index: ", index, this.chipCollectionForMultiBookingOccurenceOptions[index]); */
    if(this.chipCollectionForSingleBookingOccurenceOptions[index] && this.chipCollectionForSingleBookingOccurenceOptions[index].get(chip)) {
      return true;
    }
  }

  isSelected_SingleMultiple_BookingForEditProductAddSession(chip: any, index: number) {

    //console.log("Function: isSelected_SingleMultiple_ BookingForEditProductAddSession");
    if(this.chipCollectionForBookingEditProductAddSession[index] && this.chipCollectionForBookingEditProductAddSession[index].get(chip)) {
      return true;
    }
  }

  onClick($event: Event, chip: string) {
  console.log("Function: onClick ");
    $event.preventDefault();
    $event.stopPropagation();
    this.selectChip(chip);

    const selected = this.getSelected();
    // console.log(selected);
  }

  onClickMultiBookingChips($event: Event, chip: string, index: number) {
  console.log("Function: onClickMultiBookingChips ");
    $event.preventDefault();
    $event.stopPropagation();
    this.selectChipMultiBooking(chip, index);

    const selected = this.getSelectedMultiBookingOption();
    //console.log(selected);
  }

  onClickSingleBookingChips($event: Event, chip: string, index: number) {
  console.log("Function: onClickSingleBookingChips ");
    $event.preventDefault();
    $event.stopPropagation();
    this.selectChipSingleBooking(chip, index);

    const selected = this.getSelectedSingleBookingOption();
    //console.log(selected);
  }

  onClickSingleBookingChipsEditProductAddSession($event: Event, chip: string, index: number) {
    console.log("Function: onClickSingleBookingChipsEditProductAddSession ");
    $event.preventDefault();
    $event.stopPropagation();
    this.selectChipBookingEditProductAddSession(chip, index);

    console.log(this.clickedProductDetails.sessions)
    console.log(this.noOfSessionAddedInProductEditButNotSubmit);
    //this.isOverlapping(,this.clickedProductDetails.sessions)

  }

  getTime(timeStr) {
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "PM" && hours < 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    return hours * 60 + minutes;
  }

  isTimeOverlap(start1, end1, start2, end2) {
    return start1 < end2 && start2 < end1;
  }

  isOverlapping(newSlot, existingSlots) {
    const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

    const newStart = this.getTime(newSlot.startTime);
    const newEnd = this.getTime(newSlot.endTime);

    return existingSlots.some(slot => {
      return days.some(day => {
        return newSlot[day] && slot[day] && this.isTimeOverlap(
          newStart, newEnd,
          this.getTime(slot.startTime), this.getTime(slot.endTime)
        );
      });
    });
  }



  selectChip(chip: string) {
    if (this.chipCollection.get(chip)) {
      this.chipCollection.set(chip, false);
    } else {
      this.chipCollection.set(chip, true);
    }
  }
  selectChipMultiBooking(chip: string, index: number) {
    console.log("Function: selectChipMultiBooking");

    // Get existing map or initialize
    let existingMap = this.chipCollectionForMultiBookingOccurenceOptions[index];

    if (!existingMap) {
      existingMap = new Map<string, boolean>();
    }


    // Get current value (default false)
    const currentValue = existingMap.get(chip) || false;

    // 🔥 Create NEW map (critical for UI update)
    const updatedMap = new Map<string, boolean>(existingMap);

    // Toggle selection
    updatedMap.set(chip, !currentValue);

    // Assign back (new reference)
    this.chipCollectionForMultiBookingOccurenceOptions[index] = updatedMap;
  }

   selectChipSingleBooking(chip: string, index: number) {
     console.log("Function: selectChipSingleBooking");

     // Get existing map or create new
     let existingMap = this.chipCollectionForSingleBookingOccurenceOptions[index];

     if (!existingMap) {
       existingMap = new Map<string, boolean>();
     }

     // Get current value (default false)
     const currentValue = existingMap.get(chip) || false;

     // 🔥 Create NEW map reference (important for Angular change detection)
     const updatedMap = new Map<string, boolean>(existingMap);

     // Toggle value
     updatedMap.set(chip, !currentValue);

     // Assign new reference back
     this.chipCollectionForSingleBookingOccurenceOptions[index] = updatedMap;
   }

  clearChipBookingEditProductAddSession() {
  console.log("Function: clearChipSingleBookingEditProductAddSession ");
    //console.log("Function: clearChipSingleBookingEditProductAddSession");
    this.chipCollectionForBookingEditProductAddSession = [];
  }

  selectChipBookingEditProductAddSession(chip: string, index: number) {
  console.log("Function: selectChipSingleBookingEditProductAddSession ");
    //console.log(chip);
    //console.log(index);
   // console.log("Function: selectChipSingleBookingEditProductAddSession");
    if (this.chipCollectionForBookingEditProductAddSession[index] && this.chipCollectionForBookingEditProductAddSession[index].get(chip)) {
       //console.log(this.chipCollectionForMultiBookingOccurenceOptions[index].get(chip));
      const nestedMapValue = this.chipCollectionForBookingEditProductAddSession[index];
      nestedMapValue.set(chip, false);
      this.chipCollectionForBookingEditProductAddSession[index] = nestedMapValue;
    } else if (this.chipCollectionForBookingEditProductAddSession[index] && !this.chipCollectionForBookingEditProductAddSession[index].get(chip)) {
       //console.log(this.chipCollectionForMultiBookingOccurenceOptions[index].get(chip));
      const nestedMapValue = this.chipCollectionForBookingEditProductAddSession[index];
      nestedMapValue.set(chip, true);
      this.chipCollectionForBookingEditProductAddSession[index] = nestedMapValue;
    } else {
      //console.log('In else part');
      this.chipCollectionForBookingEditProductAddSession[index] = new Map();
      this.chipCollectionForBookingEditProductAddSession[index].set(chip, true);
      // this.chipCollectionForMultiBookingOccurenceOptions.splice(index, 0, new Map().set(chip, true));
    }
  }

  getSelected() {
    const selected = <string[]>[];

    Array.from(this.chipCollection.entries(), (v: [ string, boolean ]) => {
      if (v[ '1' ]) {
        selected.push(v[ '0' ]);
      }
    });

    return selected;
  }

  getSelectedMultiBookingOption() {
  console.log("Function: getSelectedMultiBookingOption ");
    return this.chipCollectionForMultiBookingOccurenceOptions;
  }

  getSelectedSingleBookingOption() {
  console.log("Function: getSelectedSingleBookingOption ");
    return this.chipCollectionForSingleBookingOccurenceOptions;
  }

  getSelectedBookingEditProductAddSession() {
    //console.log("Function: getSelectedBookingEditProductAddSession ");
    console.log("Function: getSelectedSingleBookingEditProductAddSession");
    return this.chipCollectionForBookingEditProductAddSession;
  }


   clickedAdvancedPricingForExistingSessions(index: number, sessionId) {

     //console.log("Function: clickedAdvancedPricingForExistingSessions");
     //console.log("isfreshlyOpened index", this.isfreshlyOpened.get(index));
     //console.log("getCapacityPerVenueRequired", this.getCapacityPerVenueRequired());

     this.sessionIDofSelectedSessionOfExistingProduct = sessionId;

     // 🔥 Existing sessions do not use dropdown selection events,
     // so populate start/end arrays manually.
     const session = this.clickedProductDetails.sessions[index];

     this.selectedStartTimeValue[index] = session.startTime;
     this.selectedEndTimeValue[index] = session.endTime;

     // Existing sessions already have times
     if (!session.startTime || !session.endTime) {
       alert("Please select Start Time and End Time first.");
       return;
     }

     if (!this.getCapacityPerVenueRequired()) {

       this.deriveTimeSlots(index);

       // 🔥 pass true for existing session pricing
       this.displayAdvancePricingPopup(index, true);

     } else {

       alert("Enter Rate, Duration, Capacity, Start Time and End Time before opening advanced pricing.");
     }
   }


  clickedAdvancedPricing(index: number) {
      console.log("Function: clickedAdvancedPricing");
      //console.log("isfreshlyOpened index", this.isfreshlyOpened.get(index));
      //console.log("getCapacityPerVenueRequired", this.getCapacityPerVenueRequired())

      if (!this.isStartEndTimeSelected(index) ) {
          alert("Please select Start Time and End Time first.");
          return;
      }

      if(!this.getCapacityPerVenueRequired())
      {
        this.deriveTimeSlots(index);
        this.displayAdvancePricingPopup(index, false);
      }
      else {
          alert("Enter Rate, Duration, Capacity before opening advanced pricing.");
        }

    }
    get canShowSessions(): boolean {
      // 🚫 Flexi/Open product or AddOn → no sessions ever
      if (this.openProductSelected || this.showAddOnOption) return false;

      const form = this.productFormGroup;

      return form.get('productNameFormControl')?.value &&
             form.get('productDescriptionFormControl')?.value &&
             form.get('productRateFormControl')?.value &&
             form.get('productDurationFormControl')?.value > 0;
    }


  deriveTimeSlots(index: number)
  {
      console.log("Function: deriveTimeSlots : Common for Single and Multiple Index", index);


      if (this.sessionIDofSelectedSessionOfExistingProduct != null && this.clickedProductDetails.sessions[index] )
      {
        // Only populate for EXISTING sessions
        if (!this.selectedStartTimeValue[index] && !this.selectedEndTimeValue[index])
         {
            this.selectedStartTimeValue[index] = this.clickedProductDetails.sessions[index].startTime;
          this.selectedEndTimeValue[index] = this.clickedProductDetails.sessions[index].endTime;
        }
        this.sessionIDofSelectedSessionOfExistingProduct = null;
      }
      const startTime = this.parseTime(this.convert12HourTo24HourFormat(this.selectedStartTimeValue[index]));
      let endTime = this.parseTime(this.convert12HourTo24HourFormat(this.selectedEndTimeValue[index]));
      //console.log("x");
      //console.log(endTime);
      if(endTime == 0) {endTime = 1440}
      let timeSlots: Array<string> = new Array<string>();
      let i;
      let durationInMinutes;
      if (this.showUpdateProductForm)
      {
        durationInMinutes = this.updateproductFormGroup.get('updateProductDurationFormControl').value;
      }
      else
      {
        durationInMinutes = this.productFormGroup.get('productDurationFormControl').value;
      }
      //console.log("Function: deriveTimeSlots : Common for Single and Multiple 2");
      for(i = startTime; i <= endTime; i = i + durationInMinutes) {
        //console.log(this.convertHours(i));
        //console.log(this.tConvert(this.convertHours(i)));
        if(i == 1440) {
          timeSlots.push("12:00 AM");
        } else {
          timeSlots.push(this.tConvert(this.convertHours(i)));
          //console.log("Function: deriveTimeSlots : Common for Single and Multiple 3");
        }
      }
      //console.log("Function: deriveTimeSlots : Common for Single and Multiple 4");
      //console.log(timeSlots);

      this.timeSlotsForAdvancePricing[index] = timeSlots;
      //console.log(this.timeSlotsForAdvancePricing);
  }

  tConvert (time) {
    // Check correct time format and split into components
    time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    //console.log(time);
    if (time.length > 1) { // If time format correct
      time = time.slice (1);  // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join (''); // return adjusted time or original string
  }

  convertHours(minutes: number) {
    const hour = Math.floor(minutes / 60);
    const min = minutes % 60;
    const str = this.addPadding(String(hour), 2) + ':' + this.addPadding(String(min), 2);
    return str;
  }

  addPadding(str: string, max: number) {
    if(str.length < max) {
      return this.addPadding('0' + str, max);
    }  else {
      return str;
    }
  }

  parseTime(time: string) {
    if(!time){
      return;
    }
    const splitTimeString = time.split(':');
    const parseTimeStringToInt = Number(splitTimeString[0]) * 60 + Number(splitTimeString[1]);
    return parseTimeStringToInt;
  }

  convert12HourTo24HourFormat(time12h: string) {
    if(!time12h){
      return;
    }
    const [time, modifier] = time12h.split(' ');

    let [hours, minutes] = time.split(':');

    if (hours === '12') {
      hours = '00';
    }
    let hoursInNumber: any = hours;
    if (modifier === 'PM') {
      hoursInNumber = parseInt(hours, 10) + 12;
    }

    return `${hoursInNumber}:${minutes}`;
  }

  get productFormControls() {
    return this.productFormGroup.controls;
  }

  get updateProductFormControls() {
    return this.updateproductFormGroup.controls;
  }

 /*  selectValueChangeForStartTime() {

  } */

  selectValueChangeForStartTime(startTime: string, index: number) {
    console.log("Function: selectValueChangeForStartTime ");
    this.selectedStartTimeValue[index] = startTime;
    //console.log(this.selectedStartTimeValue);
     this.updateEndTimeOptions(startTime);
     //console.log("Filtered End time options", this.filteredEndTimeOptions);
  }

  updateEndTimeOptions(startTime) {

     console.log("Selected Start Time", startTime);
     let x = this.convertTimeToDate(startTime);
     //console.log("x: ", x);
    if (!x) {
      this.filteredEndTimeOptions = [...this.endTimeOptions]; // Show all if no start time selected
      console.log("Returniing ");

      return;
    }

    // Convert selected start time to Date for comparison
    let startTimeDate = this.convertTimeToDate(startTime);
    this.filteredEndTimeOptions = this.startTimeOptions;

     this.filteredEndTimeOptions = this.endTimeOptions.filter(time => {
      let endTimeDate = this.convertTimeToDate(time);
      return endTimeDate > startTimeDate; // Only keep end times later than start time
    });
    //console.log("Filtered End time options Before ", this.filteredEndTimeOptions);
    this.filteredEndTimeOptions.push(this.datePipe.transform(this.dateObj.setHours(0, this.zeros), 'h:mm a'));

   }

  convertTimeToDate(time: string): Date {
    let date = new Date();
    let [timeString, period] = time.split(' ');
    let [hours, minutes] = timeString.split(':').map(Number);

    if (period === 'PM' && hours !== 12) {
      hours += 12;
    } else if (period === 'AM' && hours === 12) {
      hours = 0;
    }

    date.setHours(hours, minutes, 0, 0);
    return date;
  }

  selectValueChangeForEndTime(endTime: string, index: number) {
  console.log("Function: selectValueChangeForEndTimeSingleBooking ");
    this.selectedEndTimeValue[index] = endTime;
    console.log(this.selectedEndTimeValue);
  }

  clickedDeleteActionsMultiBooking(index: number) {

    console.log("Function: clickedDeleteActionsMultiBooking");
    this.chipCollectionForMultiBookingOccurenceOptions.splice(index, 1);
    this.selectedStartTimeValue.splice(index, 1);
    this.selectedEndTimeValue.splice(index, 1);
    this.selectedFrequencyValue = this.selectedFrequencyValue - 1;
    //console.log("Deleted entries at index: " + index);
    this.addSessionClicked = false;
  }

  clickedDeleteActionsSingleBooking(index: number) {
    console.log("Function: clickedDeleteActionsSingleBooking");
    this.chipCollectionForSingleBookingOccurenceOptions.splice(index, 1);
    this.selectedStartTimeValue.splice(index, 1);
    this.selectedEndTimeValue.splice(index, 1);
    this.selectedFrequencyValue = this.selectedFrequencyValue - 1;
    this.noOfSessionsToDisplay = this.noOfSessionsToDisplay - 1;
    //console.log("Deleted entries at index: " + index);
    this.addSessionClicked = false;
  }

  inputValueChangeForSessionsFrequency() {

  }



  clearMessageAfterDelay() {
    setTimeout(() => {
      this.successMessage = '';
      this.errorMessage = '';
    }, 5000);
  }
  closeProductForms() {
    this.showAddNewProductForm = false;
    this.showUpdateProductForm = false;
  }
  getServiceName(serviceTypeIcon: string): string {

      return AppConstants.SERVICE_TYPE_NAMES[serviceTypeIcon]
          || serviceTypeIcon?.replace('.svg', '');
    }

  onCreateProductFormSaveClicked() {
    console.log("Function: onCreateProductFormSaveClicked ");
    const productName = this.productFormGroup.get('productNameFormControl').value?.trim();
    const productName_backup = this.productFormGroup.get('productNameFormControl').value?.trim()?.toLowerCase();
    const description = this.productFormGroup.get('productDescriptionFormControl').value;
    const price = this.productFormGroup.get('productRateFormControl').value;
    const durationPerSlot = this.productFormGroup.get('productDurationFormControl').value;
    const capacityPerVenue = this.productFormGroup.get('productCapacityPerVenueFormControl').value;
    const productType = this.showSingleBookingsOption ? AppConstants.SINGLE_SESSION : AppConstants.MULTI_SESSION;
    const productStatus = this.getProductStatusValue();
    const isFlexible = this.showMultipleBookingsOption && this.selectedProductSubTypeValue === "Flexible";
    const noOfMonths = this.productFormGroup.get('selectedFrequencyValue').value;

    const duplicateProduct = this.rowData.find(product =>
        product.productName?.trim()?.toLowerCase() === productName_backup
      );

    if (duplicateProduct) {

      alert('Service name already exists.');

      return;
    }

    if (this.showAddOnOption) {
      this.createAddOn(productName, description, price, productStatus);
      return;
    }

    const allowBooking = this.productFormGroup.get('allowBookingFormControl').value;
    const isCoaching  = this.productFormGroup.get('isCoachingFormControl').value;
    const serviceType = this.productFormGroup.get('serviceTypeFormControl').value;

    if(this.showSingleBookingsOption)
    {
      const productRequest = {
        productName: productName,
        description: description,
        status: productStatus,
        price: Number(price),
        durationPerSlot: durationPerSlot,
        capacityPerVenue: capacityPerVenue,
        productType: productType,
        tenantId: this.tenantId,
        allowBooking: allowBooking,
        isCoaching: isCoaching,
        serviceType: serviceType,
        ...this.getBookingWindowPayload(this.productFormGroup, 'bookingWindow')
      }
        /* console.log(
          'allowBooking control:',
          this.productFormGroup.get('allowBookingFormControl')?.value
        );

        console.log(
          'isCoaching control:',
          this.productFormGroup.get('isCoachingFormControl')?.value
        );

        console.log('productRequest:', productRequest); */
      this.authService.createProduct(productRequest).subscribe(
        (response: any) => {
          console.log('Service created successfully.');
          console.log(response);

          this.snackBar.open('Service created successfully!', '', {
                    duration: 5000,
                    verticalPosition: 'bottom',
                    horizontalPosition: 'center',
                    panelClass: ['snackbar-success']
                  });
          const getSelectedSingleBookingOptionForSession = this.getSelectedSingleBookingOption();
          //console.log(getSelectedSingleBookingOptionForSession);

          //console.log("timeSlotsForAdvancePricing", this.timeSlotsForAdvancePricing);
          if(this.timeSlotsForAdvancePricing.length == 0)
          {
            for(let counter = 0; counter < getSelectedSingleBookingOptionForSession.length; counter++) {
              this.deriveTimeSlots(counter);
              this.advancePricing[counter] = new Array<number>(this.timeSlotsForAdvancePricing[counter].length - 1).fill(response.price);
            }
          }

          for(let counter = 0; counter < getSelectedSingleBookingOptionForSession.length; counter++) {
            const timeSlotsArray = this.timeSlotsForAdvancePricing[counter];
            //console.log("timeSlotsArray: ", timeSlotsArray);
            const startTime = timeSlotsArray[0];
            const endTime = timeSlotsArray[timeSlotsArray.length - 1];

            const map = getSelectedSingleBookingOptionForSession[counter]; // or multi/edit version

            const monday = map.get(this.chips[0]) === true;
            const tuesday = map.get(this.chips[1]) === true;
            const wednesday = map.get(this.chips[2]) === true;
            const thursday = map.get(this.chips[3]) === true;
            const friday = map.get(this.chips[4]) === true;
            const saturday = map.get(this.chips[5]) === true;
            const sunday = map.get(this.chips[6]) === true;

            /* const monday = getSelectedSingleBookingOptionForSession[counter].has(this.chips[0]);
            const tuesday = getSelectedSingleBookingOptionForSession[counter].has(this.chips[1]);
            const wednesday = getSelectedSingleBookingOptionForSession[counter].has(this.chips[2]);
            const thursday = getSelectedSingleBookingOptionForSession[counter].has(this.chips[3]);
            const friday = getSelectedSingleBookingOptionForSession[counter].has(this.chips[4]);
            const saturday = getSelectedSingleBookingOptionForSession[counter].has(this.chips[5]);
            const sunday = getSelectedSingleBookingOptionForSession[counter].has(this.chips[6]); */

            const sessionRequest = {
              tenantId: this.tenantId,
              productId: response.id,
              startTime: startTime,
              endTime: endTime,
              monday: monday,
              tuesday: tuesday,
              wednesday: wednesday,
              thursday: thursday,
              friday: friday,
              saturday: saturday,
              sunday: sunday
            }

            this.authService.createSession(sessionRequest).subscribe(
              (createSessionResponse: any) => {
                //console.log('Session created successfully.');
                this.snackBar.open('Session created successfully!', '', {
                                    duration: 5000,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'center',
                                    panelClass: ['snackbar-success']
                                  });
                //console.log(createSessionResponse);
                response.sessions = [createSessionResponse];
                this.rowData = [...this.rowData, response];
                //console.log('timeSlotsArray' + timeSlotsArray);
                let timeslotWiseProductRequestArray: Array<any> = [];
                for(let i = 0; i < timeSlotsArray.length - 1; i++) {

                  /* console.log('Single Seesion counter', counter);
                   console.log('advancePricing', this.advancePricing);
                   console.log('advancePricing[counter]', this.advancePricing[counter]); */

                  const timeslotWiseProductRequest = {
                    tenantId: this.tenantId,
                    startTime: this.convert12HourTo24HourFormat(timeSlotsArray[i]),
                    endTime: this.convert12HourTo24HourFormat(timeSlotsArray[i + 1]),
                    price: this.advancePricing[counter][i],
                    productId: response.id,
                    sessionId: createSessionResponse.id
                  }
                  timeslotWiseProductRequestArray.push(timeslotWiseProductRequest);
                }

                this.authService.createTimeSlotWiseProducts(timeslotWiseProductRequestArray).subscribe(
                  (createTimeSlotWiseProductsByProductIdResponse: any) => {
                    console.log('Successfully created timeslot wise products for single booking');
                    console.log(createTimeSlotWiseProductsByProductIdResponse);
                    this.showAddNewProductForm = false;
                    this.resetCreateProductForm();
                    //window.location.reload();
                  },
                  (error) => {
                    console.log(error);
                    this.snackBar.open('Failed to create session. Please try again.', '', {
                              duration: 5000,
                              verticalPosition: 'bottom',
                              horizontalPosition: 'center',
                              panelClass: ['snackbar-error']
                            });
                  }
                );
              }
            );
          }

        },
        (error) => {
          console.log(error);
          this.snackBar.open('Failed to create Service. Please try again.', '', {
                                        duration: 5000,
                                        verticalPosition: 'bottom',
                                        horizontalPosition: 'center',
                                        panelClass: ['snackbar-error']
                                      });
        }
      );
    }
    //Flexible Product
    else if (this.showMultipleBookingsOption && this.selectedProductSubTypeValue === this.productSubTypes[1])
    {
      console.log(this.selectedOptionForMonthlyMultiBooking);
      const productRequest = {
        productName: productName,
        description: description,
        status: productStatus,
        price: Number(price),
        durationPerSlot: durationPerSlot,
        capacityPerVenue: capacityPerVenue,
        productType: productType,
        tenantId: this.tenantId,
        sessionType: this.selectedProductSubTypeValue,
        noOfSessions: Number(this.selectedFrequencyValue),
        monthlyMultiBookingOption: this.selectedOptionForMonthlyMultiBooking,
        allowBooking: allowBooking,
        isCoaching: isCoaching,
        serviceType: serviceType
      }

      this.authService.createProduct(productRequest).subscribe(
        (response: any) => {
          console.log('Product created successfully.');
          this.snackBar.open('Service created successfully!', '', {
                              duration: 5000,
                              verticalPosition: 'bottom',
                              horizontalPosition: 'center',
                              panelClass: ['snackbar-success']
                            });
          this.rowData = [...this.rowData, response];
          if (isFlexible) {
            this.closeCreateForm();
            return;
          }
          //console.log("Response: ", response);
          const getSelectedMultiBookingOptionForSession = this.getSelectedMultiBookingOption();
          //console.log("Here: ", getSelectedMultiBookingOptionForSession);
          //console.log("timeSlotsForAdvancePricing", this.timeSlotsForAdvancePricing);
          if(this.timeSlotsForAdvancePricing.length == 0)
          {
            for(let counter = 0; counter < getSelectedMultiBookingOptionForSession.length; counter++) {
              this.deriveTimeSlots(counter);
              this.advancePricing[counter] = new Array<number>(this.timeSlotsForAdvancePricing[counter].length - 1).fill(response.price);
            }
          }
          for(let counter = 0; counter < getSelectedMultiBookingOptionForSession.length; counter++) {
            const timeSlotsArray = this.timeSlotsForAdvancePricing[counter];
            //console.log("timeSlotsArray: ", timeSlotsArray);
            const startTime = timeSlotsArray[0];
            const endTime = timeSlotsArray[timeSlotsArray.length - 1];

            const map = getSelectedMultiBookingOptionForSession[counter]; // or multi/edit version

            const monday = map.get(this.chips[0]) === true;
            const tuesday = map.get(this.chips[1]) === true;
            const wednesday = map.get(this.chips[2]) === true;
            const thursday = map.get(this.chips[3]) === true;
            const friday = map.get(this.chips[4]) === true;
            const saturday = map.get(this.chips[5]) === true;
            const sunday = map.get(this.chips[6]) === true;
            /* const monday = getSelectedMultiBookingOptionForSession[counter].has(this.chips[0]);
            const tuesday = getSelectedMultiBookingOptionForSession[counter].has(this.chips[1]);
            const wednesday = getSelectedMultiBookingOptionForSession[counter].has(this.chips[2]);
            const thursday = getSelectedMultiBookingOptionForSession[counter].has(this.chips[3]);
            const friday = getSelectedMultiBookingOptionForSession[counter].has(this.chips[4]);
            const saturday = getSelectedMultiBookingOptionForSession[counter].has(this.chips[5]);
            const sunday = getSelectedMultiBookingOptionForSession[counter].has(this.chips[6]); */

            const sessionRequest = {
              tenantId: this.tenantId,
              productId: response.id,
              startTime: startTime,
              endTime: endTime,
              monday: monday,
              tuesday: tuesday,
              wednesday: wednesday,
              thursday: thursday,
              friday: friday,
              saturday: saturday,
              sunday: sunday
            }

            this.authService.createSession(sessionRequest).subscribe(
              (createSessionResponse: any) => {
                console.log('Session created successfully.');

                let timeslotWiseProductRequestArray: Array<any> = [];
                for(let i = 0; i < timeSlotsArray.length - 1; i++) {

                  const timeslotWiseProductRequest = {
                    tenantId: this.tenantId,
                    startTime: this.convert12HourTo24HourFormat(timeSlotsArray[i]),
                    endTime: this.convert12HourTo24HourFormat(timeSlotsArray[i + 1]),
                    price: this.advancePricing[counter][i],
                    productId: response.id,
                    sessionId: createSessionResponse.id
                  }
                  timeslotWiseProductRequestArray.push(timeslotWiseProductRequest);
                }

                this.authService.createTimeSlotWiseProducts(timeslotWiseProductRequestArray).subscribe(
                  (createTimeSlotWiseProductsByProductIdResponse: any) => {
                    //console.log('Successfully created timeslot wise products');
                    //console.log(createTimeSlotWiseProductsByProductIdResponse);
                    this.showAddNewProductForm = false;
                    this.resetCreateProductForm();
                    //window.location.reload();
                  },
                  (error) => {
                    console.log(error);
                    this.snackBar.open('Slot creation failed!', '', {
                                        duration: 5000,
                                        verticalPosition: 'bottom',
                                        horizontalPosition: 'center',
                                        panelClass: ['snackbar-error']
                                      });
                  }
                );
              }
            );
          }

          this.closeCreateForm();

        },
        (error) => {
          console.log(error);
          this.snackBar.open('Service creation failed!', '', {
                                                  duration: 5000,
                                                  verticalPosition: 'bottom',
                                                  horizontalPosition: 'center',
                                                  panelClass: ['snackbar-error']
                                                });

        }
      );
    }
    //Monthly Product Create
    else {
      //console.log("here I AM ******************", this.selectedOptionForMonthlyMultiBooking);
      //console.log("here I AM ******************",Number(this.selectedFrequencyValue));
      const productRequest = {
        productName: productName,
        description: description,
        status: productStatus,
        price: Number(price),
        durationPerSlot: durationPerSlot,
        capacityPerVenue: capacityPerVenue,
        productType: productType,
        tenantId: this.tenantId,
        sessionType: this.selectedProductSubTypeValue,
        noOfSessions: Number(noOfMonths),
        monthlyMultiBookingOption: this.selectedOptionForMonthlyMultiBooking,
        monthlyMultiBookingSelectedDates: this.productFormGroup.get('selectedDatesFormControl').value,
        allowBooking: allowBooking,
        isCoaching: isCoaching,
        serviceType: serviceType
      }



      this.authService.createProduct(productRequest).subscribe(
        (response: any) => {
          //console.log('Product created successfully.');
          this.snackBar.open('Slot created successfully!', '', {
                                                  duration: 5000,
                                                  verticalPosition: 'bottom',
                                                  horizontalPosition: 'center',
                                                  panelClass: ['snackbar-success']
                                                });
          this.rowData = [...this.rowData, response];
          //console.log("Response: ", response);
          const getSelectedMultiBookingOptionForSession = this.getSelectedMultiBookingOption();
          //console.log("Here: ", getSelectedMultiBookingOptionForSession);
          //console.log("timeSlotsForAdvancePricing", this.timeSlotsForAdvancePricing);
          let isOpenSession = response.sessionType === "Flexible";
          if(!isOpenSession){
            /* if(this.timeSlotsForAdvancePricing.length == 0)
            {
              for(let counter = 0; counter < this.noOfSessionsToDisplay; counter++) {
                this.deriveTimeSlots(counter);
                this.advancePricing[counter] = new Array<number>(this.timeSlotsForAdvancePricing[counter].length - 1).fill(response.price);
              }
            } */

            //console.log("Monthly");
            if(this.timeSlotsForAdvancePricing.length == 0)
            {
              for(let counter = 0; counter < getSelectedMultiBookingOptionForSession.length; counter++) {

                if(!this.timeSlotsForAdvancePricing[counter]) {

                  this.deriveTimeSlots(counter);
                }

                if(!this.advancePricing[counter]) {

                  this.advancePricing[counter] =
                    new Array<number>(
                      this.timeSlotsForAdvancePricing[counter].length - 1
                    ).fill(response.price);
                }
              }
            }


             //console.log('Done advancePricing', this.advancePricing);

            for(let counter = 0; counter < this.noOfSessionsToDisplay; counter++) {
              const timeSlotsArray = this.timeSlotsForAdvancePricing[counter];
              //console.log("timeSlotsArray: ", timeSlotsArray);
              const startTime = timeSlotsArray[0];
              const endTime = timeSlotsArray[timeSlotsArray.length - 1];

              const map = getSelectedMultiBookingOptionForSession[counter]; // or multi/edit version

              const monday = map.get(this.chips[0]) === true;
              const tuesday = map.get(this.chips[1]) === true;
              const wednesday = map.get(this.chips[2]) === true;
              const thursday = map.get(this.chips[3]) === true;
              const friday = map.get(this.chips[4]) === true;
              const saturday = map.get(this.chips[5]) === true;
              const sunday = map.get(this.chips[6]) === true;
              /* const monday = getSelectedMultiBookingOptionForSession[counter].has(this.chips[0]);
              const tuesday = getSelectedMultiBookingOptionForSession[counter].has(this.chips[1]);
              const wednesday = getSelectedMultiBookingOptionForSession[counter].has(this.chips[2]);
              const thursday = getSelectedMultiBookingOptionForSession[counter].has(this.chips[3]);
              const friday = getSelectedMultiBookingOptionForSession[counter].has(this.chips[4]);
              const saturday = getSelectedMultiBookingOptionForSession[counter].has(this.chips[5]);
              const sunday = getSelectedMultiBookingOptionForSession[counter].has(this.chips[6]); */

              const sessionRequest = {
                tenantId: this.tenantId,
                productId: response.id,
                startTime: startTime,
                endTime: endTime,
                monday: monday,
                tuesday: tuesday,
                wednesday: wednesday,
                thursday: thursday,
                friday: friday,
                saturday: saturday,
                sunday: sunday
              }

              this.authService.createSession(sessionRequest).subscribe(
                (createSessionResponse: any) => {
                  //console.log('Session created successfully.');
                  //console.log(createSessionResponse);
                  this.snackBar.open('Slot created successfully!', '', {
                                                          duration: 5000,
                                                          verticalPosition: 'bottom',
                                                          horizontalPosition: 'center',
                                                          panelClass: ['snackbar-success']
                                                        });

                  //console.log('timeSlotsArray' + timeSlotsArray);
                  let timeslotWiseProductRequestArray: Array<any> = [];
                  for(let i = 0; i < timeSlotsArray.length - 1; i++) {
                    // console.log('counter', counter);
                     //console.log('advancePricing', this.advancePricing);
                     //console.log('advancePricing[counter]', this.advancePricing[counter]);
                    const timeslotWiseProductRequest = {
                      tenantId: this.tenantId,
                      startTime: this.convert12HourTo24HourFormat(timeSlotsArray[i]),
                      endTime: this.convert12HourTo24HourFormat(timeSlotsArray[i + 1]),

                      price: this.advancePricing[counter][i],
                      productId: response.id,
                      sessionId: createSessionResponse.id
                    }
                    timeslotWiseProductRequestArray.push(timeslotWiseProductRequest);
                  }

                  this.authService.createTimeSlotWiseProducts(timeslotWiseProductRequestArray).subscribe(
                    (createTimeSlotWiseProductsByProductIdResponse: any) => {
                      //console.log('Successfully created timeslot wise products');
                      this.snackBar.open('Slot created successfully!', '', {
                                                              duration: 5000,
                                                              verticalPosition: 'bottom',
                                                              horizontalPosition: 'center',
                                                              panelClass: ['snackbar-success']
                                                            });
                      //console.log(createTimeSlotWiseProductsByProductIdResponse);
                      this.closeCreateForm();
                    },
                    (error) => {
                      console.log(error);
                      this.snackBar.open('Slot creation failed!', '', {
                                                              duration: 5000,
                                                              verticalPosition: 'bottom',
                                                              horizontalPosition: 'center',
                                                              panelClass: ['snackbar-error']
                                                            });
                    }
                  );
                }
              );
            }
          }

          if(this.selectedOptionForMonthlyMultiBooking != '') {
            this.showAddNewProductForm = false;
            //this.resetCreateProductForm();
            //window.location.reload();
          }
        },
        (error) => {
          console.log(error);
          this.snackBar.open('Service creation failed!', '', {
                                                  duration: 5000,
                                                  verticalPosition: 'bottom',
                                                  horizontalPosition: 'center',
                                                  panelClass: ['snackbar-error']
                                                });
        }
      );
    }
  }
  closeCreateForm()
  {
    this.showAddNewProductForm = false;
    this.resetCreateProductForm();
    this.getAllProductsByTenantId();
  }

  onCreateProductFormCancelClicked()
  {
   this.resetCreateProductForm();
    this.showAddNewProductForm = false;
    this.productFormGroup.reset({
      productCapacityPerVenueFormControl: 1,
      selectedFrequencyValue: 1,
      allowBookingFormControl: true,
      isCoachingFormControl: true
    });
    this.productFormGroup.markAsPristine(); // Marks form as untouched
    this.productFormGroup.markAsUntouched(); // Clears validation errors
    this.sessionIdsToDelete.length = 0;
    this.isCapacityPerVenueRequired = false;
    // rates = [];
    this.removable = true;
    this.showMultipleBookingsOption = false;
    this.showSingleBookingsOption = false;
    this.selectedStartTimeValue.length = 0;
    this.advancePricing.length = 0;
    this.selectedEndTimeValue.length = 0;
    this.timeSlotsForAdvancePricing.length = 0;
    this.chipCollectionForSingleBookingOccurenceOptions.length = 0;
    this.chipCollectionForMultiBookingOccurenceOptions.length = 0;
    this.startTimeOptions.length = 0;
    this.endTimeOptions.length = 0;


  }

  clearCreateAndUpdateFormData()
  {
    this.productFormGroup.reset({
      productCapacityPerVenueFormControl: 1,
      selectedFrequencyValue: 1,
      allowBookingFormControl: true,
      isCoachingFormControl: true,
    });
    this.productFormGroup.markAsPristine(); // Marks form as untouched
    this.productFormGroup.markAsUntouched(); // Clears validation errors
    this.sessionIdsToDelete.length = 0;
    this.isCapacityPerVenueRequired = false;
    this.removable = true;
    this.showMultipleBookingsOption = false;
    this.showSingleBookingsOption = false;
    this.selectedStartTimeValue.length = 0;
    this.advancePricing.length = 0;
    this.selectedEndTimeValue.length = 0;
    this.timeSlotsForAdvancePricing.length = 0;
    this.chipCollectionForSingleBookingOccurenceOptions.length = 0;
    this.chipCollectionForMultiBookingOccurenceOptions.length = 0;
    this.startTimeOptions.length = 0;
    this.endTimeOptions.length = 0;
    this.filteredEndTimeOptions.length = 0;
    this.clickedProductDetails = null;

    this.advancePricing = [];
    this.sessionIDofSelectedSessionOfExistingProduct = null;
    this.addSessionClicked = false;
    this.noOfSessionAddedInProductEditButNotSubmit = 0;
    this.showAddOnOption = false;
    this.addOnImageError = '';
    this.clearAddOnImage();
  }

  getProductStatusValue() {
    if(this.isChecked) {
      return AppConstants.STATUS_ACTIVE.charAt(0).toUpperCase() + AppConstants.STATUS_ACTIVE.slice(1);
    } else {
      return AppConstants.STATUS_INACTIVE.charAt(0).toUpperCase() + AppConstants.STATUS_INACTIVE.slice(1);
    }
  }

  onAdvancePricingCancelClicked() {
    console.log("Function: onAdvancePricingCancelClicked ");
    this.modalPopupReference.dismiss();
  }


  onAdvancePricingCancelClickedSingleBookingEditProduct() {
    console.log("Function: onAdvancePricingCancelClickedSingleBookingEditProduct ");
    this.modalPopupReferenceEditProduct.dismiss();
  }
  onAdvancePricingSaveClicked() {

    console.log("Function: onAdvancePricingSaveClicked ");

    // NEW SESSION
    if (
      !this.clickedProductDetails ||
      !this.clickedProductDetails.sessions ||
      !this.clickedProductDetails.sessions[this.advanceModalPopupOpenedIndex]
    ) {

      /* console.log(
        'New session pricing stored locally',
        this.advancePricing[this.advanceModalPopupOpenedIndex]
      ); */

      if (this.modalPopupReference) {
        this.modalPopupReference.close();
      }

      return;
    }

    // EXISTING SESSION
    let timeslotWiseProductRequestArray =
      this.clickedProductDetails.sessions[this.advanceModalPopupOpenedIndex]
        ?.timeslotWiseProduct || [];

    //console.log(timeslotWiseProductRequestArray);

    const timePairs = timeslotWiseProductRequestArray.map(item => ({
      startTime: item.startTime,
      endTime: item.endTime,
      sessionId: item.sessionId,
      tenantId: item.tenantId,
      productId: item.productId
    }));

    const uniquePairs = Array.from(
      new Map(
        timePairs.map(pair => [
          JSON.stringify({
            startTime: pair.startTime,
            endTime: pair.endTime
          }),
          pair
        ])
      ).values()
    );

    uniquePairs.sort((a: any, b: any) => {

      const [aHour, aMin] = a.startTime.split(':').map(Number);
      const [bHour, bMin] = b.startTime.split(':').map(Number);

      return aHour - bHour || aMin - bMin;
    });

    const merged = uniquePairs.map((pair: any, index) => ({
      startTime: pair.startTime,
      endTime: pair.endTime,
      sessionId: pair.sessionId,
      tenantId: pair.tenantId,
      productId: pair.productId,
      price: Number(
          this.advancePricing[
              this.advanceModalPopupOpenedIndex
          ][index]
      )
    }));
    /* const values = $(".advance-cost").map(function () {
      return $(this).val();
    }).get();

    //console.log('Advance prices:', values);

    const merged = uniquePairs.map((pair: any, index) => ({
      startTime: pair.startTime,
      endTime: pair.endTime,
      sessionId: pair.sessionId,
      tenantId: pair.tenantId,
      productId: pair.productId,
      price: values[index] !== undefined
        ? Number(values[index])
        : null
    })); */

    //console.log('Merged result:', merged);

    this.authService.updateTimeSlotWiseProducts(merged).subscribe(

      (response: any) => {



        if (
          this.clickedProductDetails &&
          this.clickedProductDetails.sessions &&
          this.clickedProductDetails.sessions[
            this.advanceModalPopupOpenedIndex
          ]
        ) {

          this.clickedProductDetails.sessions[
            this.advanceModalPopupOpenedIndex
          ].timeslotWiseProduct = response;
        }

        this.getAllProductsByTenantId();

        this.advancePricing = [];

        this.snackBar.open('Pricing update successful!', '', {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: ['snackbar-success']
        });

        if (this.modalPopupReference) {
          this.modalPopupReference.close();
        }
      },

      (error: HttpErrorResponse) => {

        console.log(error);

        this.snackBar.open('Pricing update failed!', '', {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: ['snackbar-error']
        });

        if (this.modalPopupReference) {
          this.modalPopupReference.dismiss();
        }
      }
    );
  }


  isStartEndTimeSelected(index: number): boolean
  {
    const start = this.selectedStartTimeValue[index];
    const end = this.selectedEndTimeValue[index];

    return !!start && !!end;
  }


  onAdvancePricingSaveClickedEditSingleBooking() {
      console.log("Function: onAdvancePricingSaveClickedEditSingleBooking ");
      //console.log(this.timeSlotsForSingleBookingEditProductAddSession[this.advanceModalPopupOpenedIndexSingleBookingEditProduct]);
      //console.log(this.advancePricingForSingleBookingEditSession[this.advanceModalPopupOpenedIndexSingleBookingEditProduct]);
      this.modalPopupReferenceEditProduct.dismiss();
  }

  getNextIndexForTimeSlotsInModalPopup(currentIndex) {
    //console.log("Function: getNextIndexForTimeSlotsInModalPopup ");
    const nextIndex = currentIndex + 1;
    return nextIndex;
  }

  addSession(noOfSessionsToDisplay) {
    console.log("Function: addSession");
    if (!this.canShowSessions) return;
    this.noOfSessionsToDisplay = this.noOfSessionsToDisplay + 1;

    this.addSessionClicked = true;


  }

  get getIsSelectedDateRequired() {
    //console.log("Function: getIsSelectedDateRequired ");
   return this.selectedOptionForMonthlyMultiBooking === this.radioOptionsSetForMonthlyMultiBooking[1] && this.productFormGroup.get('selectedDatesFormControl').value === '';
  }
}
